import ApplicationContainer from "./ApplicationContainer";

export default ApplicationContainer;
